/* PrimeBuild – Avisos de envío (2026-10-13)
   1) Fichas: rellena "Arrives <día> – <día>" con los días hábiles de cada producto (data-min / data-max).
   2) Mini carrito (pbp-cart-notify): cambia la nota por "Free US shipping" si todo el carrito es de envío gratis
      (ningún producto con la etiqueta envio-con-costo), o "Shipping calculated at checkout" si no. */
(function () {
  if (window.__pbpShip) return;
  window.__pbpShip = true;

  function addBusinessDays(n) {
    var d = new Date();
    d.setHours(12, 0, 0, 0);
    var c = 0;
    while (c < n) {
      d.setDate(d.getDate() + 1);
      var w = d.getDay();
      if (w !== 0 && w !== 6) c++;
    }
    return d;
  }
  function fmt(d) {
    try { return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }); }
    catch (e) { return d.toDateString().slice(0, 10); }
  }
  function etaText(min, max) {
    var a = fmt(addBusinessDays(min));
    var b = fmt(addBusinessDays(max));
    return a === b ? 'Arrives by ' + b : 'Arrives ' + a + ' – ' + b;
  }

  function fillBadges(root) {
    var els = (root || document).querySelectorAll('[data-pbp-ship]:not([data-pbp-done])');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      el.setAttribute('data-pbp-done', '');
      var min = parseInt(el.getAttribute('data-min'), 10);
      var max = parseInt(el.getAttribute('data-max'), 10);
      if (!(min > 0)) continue;
      if (!(max >= min)) max = min;
      var eta = el.querySelector('[data-pbp-eta]');
      var main = el.querySelector('.pbp-ship__main');
      if (!eta) continue;
      var t = etaText(min, max);
      if (el.getAttribute('data-pbp-ship') === 'paid') {
        eta.textContent = t + ' · ';
        if (main) main.textContent = 'shipping calculated at checkout';
      } else {
        eta.textContent = ' · ' + t;
      }
      eta.title = 'Estimated delivery: ' + min + (max !== min ? '–' + max : '') + ' business days';
      eta.hidden = false;
    }
  }

  /* --- Mini carrito --- */
  var tagCache = {};
  try { tagCache = JSON.parse(sessionStorage.getItem('pbpShipTags') || '{}') || {}; } catch (e) { tagCache = {}; }
  function saveCache() { try { sessionStorage.setItem('pbpShipTags', JSON.stringify(tagCache)); } catch (e) {} }
  function isPaid(handle) {
    if (handle in tagCache) return Promise.resolve(tagCache[handle]);
    return fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        var paid = !!(p && p.tags && p.tags.indexOf('envio-con-costo') > -1);
        tagCache[handle] = paid; saveCache();
        return paid;
      })
      .catch(function () { return true; });
  }
  var truck = '<svg viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M3 8h15v13H3zM18 13h6l4 4v4h-10"/><circle cx="8.5" cy="23.5" r="2.5"/><circle cx="23.5" cy="23.5" r="2.5"/></svg>';
  function fillMiniCart() {
    var note = document.querySelector('.pbp-cn .pbp-cn__note:not([data-pbp-done])');
    if (!note) return;
    note.setAttribute('data-pbp-done', '');
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var handles = (cart.items || []).map(function (i) { return i.handle; });
        if (!handles.length) return;
        return Promise.all(handles.map(isPaid)).then(function (res) {
          var anyPaid = res.some(function (x) { return x; });
          note.classList.add('pbp-cn__note--ship');
          note.innerHTML = anyPaid
            ? 'Shipping and taxes calculated at checkout.'
            : '<strong class="pbp-ship-free">' + truck + 'Free US shipping</strong> · Taxes shown at checkout.';
        });
      })
      .catch(function () {});
  }

  var queued = false;
  function run() {
    queued = false;
    fillBadges(document);
    fillMiniCart();
  }
  function queue() { if (!queued) { queued = true; setTimeout(run, 30); } }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  try {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes && muts[i].addedNodes.length) { queue(); return; }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}
})();
